import React from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './popchart.scss';
am4core.useTheme(am4themes_animated);
am4core.addLicense('CH87155574');

const initChart = (ref, data) => {
  const chart = am4core.create(ref, am4charts.XYChart);

  chart.data = data;

  // Create axes
  const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.dataFields.category = 'geo';
  categoryAxis.numberFormatter.numberFormat = '#';
  categoryAxis.renderer.inversed = false;
  categoryAxis.renderer.grid.template.location = 0;
  categoryAxis.renderer.cellStartLocation = 0.1;
  categoryAxis.renderer.cellEndLocation = 0.9;
  categoryAxis.renderer.labels.template.fill = am4core.color('#fff');
  categoryAxis.renderer.grid.template.disabled = true;
  categoryAxis.renderer.grid.template.truncate = false;

  const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  valueAxis.renderer.opposite = false;
  valueAxis.renderer.grid.template.disabled = true;
  valueAxis.renderer.labels.template.disabled = true;

  // Create series
  function createSeries (field, name) {
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = field;
    series.dataFields.categoryX = 'geo';
    series.name = name;
    series.columns.template.tooltipText = '{name}: [bold]{valueY}[/]';
    series.columns.template.height = am4core.percent(100);
    series.sequencedInterpolation = false;

    const valueLabel = series.bullets.push(new am4charts.LabelBullet());
    valueLabel.label.text = '{valueY}K';
    valueLabel.label.dy = -10;
    valueLabel.label.fill = am4core.color('#fff');
    valueLabel.label.hideOversized = false;
    valueLabel.label.truncate = false;
    const bullet = series.bullets.push(new am4charts.LabelBullet());
    bullet.label.text = '{name}';
    bullet.label.rotation = 0;
    bullet.label.truncate = false;
    bullet.label.hideOversized = false;
    bullet.dy = 10;

    chart.maskBullets = false;
    chart.paddingBottom = '50px';
  }

  createSeries('current', 'Current');
  createSeries('future', 'Future');
  categoryAxis.renderer.grid.push(new am4charts.Grid()).disabled = true;
  valueAxis.renderer.grid.push(new am4charts.Grid()).disabled = true;

  return chart;
};

const PopChart = (props) => {
  const chartRef = React.useRef();
  const defaultData = [
    {geo: 'Zip Code', current: 1, future: 1},
    {geo: 'State', current: 1, future: 1}
  ];
  const [chart, setChart] = React.useState();
  React.useEffect(() => {
    const newchart = initChart(chartRef.current, defaultData);
    setChart(newchart);
  }, []);
  React.useEffect(() => {
    if (chart) {
      chart.data = props.data;
    }
  }, [props.data]);

  return (
    <div
      ref={chartRef}
      id="chartdiv"
      className="chartdiv"
      style={{width: '100%', height: '100%'}}
    ></div>
  );
};
PopChart.updateData = (newData) => {};
export default PopChart;
